import { CountryItem } from './countryTypes'
import { filterAndSortFields } from './../identifyUtils.ts'
import {
  email,
  phonenumber,
  phonenumberNorway,
  firstName,
  lastName,
  address1,
  address2,
  zip,
  zipNorway,
  city
} from './../identifyFields.ts'
import { bankIdNo, frejaId, manual } from './../providers/index.ts'

export const norway: object = (fieldsToInclude, KYCFields = false): CountryItem => {
  let fields = [
    email,
    {
      ...phonenumber,
      ...phonenumberNorway
    },
    firstName,
    lastName,
    address1,
    address2,
    {
      ...zip,
      ...zipNorway
    },
    city
  ]
  const providers = [
    manual
    // bankIdNo
    // frejaId
  ]
  const settings = {
    rememberDevice: true, // should it be an opt in or opt out
    storeData: true // should it be an opt in or opt out
  }
  if (fieldsToInclude) {
    // filter out based on the passed in fields and only returned the matching ones
    fields = filterAndSortFields(fields, fieldsToInclude)
  } else if (KYCFields) {
    fields = fields.filter(field => field.includeInKYC === undefined || field.includeInKYC === true) // Don't include fields we only use in the identity wizard
  }

  return {
    fields,
    providers,
    settings
  }
}
